let Widget3dsoft = require('./Main.js');

/**
 * 
 * @param widget3Dsoft self
 * @returns {undefined}
 */
Widget3dsoft.prototype.showConfirmation = function (self) {
    if (this.verifStepClientDone()) {
        $(self.sClass + ' .widget3Dsoft-loading').show();
        
        self.ajax('POST',
            this.sServerURL + 'widget/confirmation' + this.sParamsGet,
            {},
            function (response) {
               $(self.sClass).html(response);
               self.initRdv(self);
               
               //Ajout de l'evenement click sur le lien Revenir a l'accueil
               $(self.sClass + ' .showFormSearchClient').click(function(){
                   self.showFormSearchClient();
               });
               self.adaptDimensions(self);
               self.headerProfil(self);
               self.bAjaxTermine3Dsoft = true;
            }
        );
        
    }
};